import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const AboutMobile = ({ about, language }) => {
  const { t } = useTranslation();
  const isRTL = language == 'ar' ? true : false;

  return (
    <div className="relative py-16 bg-stone-50">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-stone-200/50 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-stone-200/50 rounded-full blur-3xl"></div>
      </div>

      <div className="container relative px-4 mx-auto">
        <div className="space-y-12">
          {/* Header Section */}
          <div className="text-center space-y-4" data-aos="fade-up">
            <span className="inline-block px-4 py-1.5 text-sm font-medium tracking-wider text-stone-800 rounded-full bg-stone-200">
              {about.title}
            </span>
            <h2 className="text-4xl font-light tracking-tight text-stone-900">
              {about.headline}
            </h2>
          </div>

          {/* Main Image & Description */}
          <div className="space-y-8">
            <div className="overflow-hidden rounded-3xl aspect-[4/3]" data-aos="fade-up">
            <img src={about.image_1} alt="About Us" className="object-cover w-full h-full transform transition-transform hover:scale-105" />
            </div>
            <p className="text-lg leading-relaxed text-stone-600" data-aos="fade-up">
              {about.description}
            </p>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 gap-4" data-aos="fade-up">
            <motion.div whileHover={{ scale: 1.02 }} className="p-6 text-center rounded-2xl bg-white shadow-sm">
              <div className="mb-2 text-4xl font-bold text-stone-900">{about.years_experience}+</div>
              <div className="text-sm font-medium text-stone-600">{t('about.expereince')}</div>
            </motion.div>
            <motion.div whileHover={{ scale: 1.02 }} className="p-6 text-center text-white rounded-2xl bg-stone-900">
              <div className="mb-1 text-3xl font-bold text-white">100%</div>
              <div className="text-sm font-medium text-white">{t('about.clients')}</div>
            </motion.div>
          </div>

          {/* Countries Section */}
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4" data-aos="fade-up">
              {about.countries.map((country, index) => (
                <motion.div
                  key={index}
                  whileHover={{ scale: 1.02 }}
                  className="p-5 bg-white rounded-2xl shadow-sm"
                >
                  <div className="flex flex-col items-center space-y-3 sm:flex-row sm:items-start sm:space-y-0 sm:space-x-4">
                    <div className={`overflow-hidden mx-auto w-12 h-12 rounded-full sm:mx-0 ${isRTL ? 'mr-2 text-right' : ''}`}>
                      <img
                        src={`/assets/flags/${country.icon}.svg`}
                        alt={`${country.title} flag`}
                        className="object-cover w-full h-full"
                      />
                    </div>
                    <div className={`flex flex-col text-center  ${isRTL ? 'sm:text-right' : 'sm:text-left'}`}>
                      <div className="text-xl font-bold text-gray-800 truncate">{country.title}</div>
                      <div className="text-sm text-gray-800">{t('about.operating')}</div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMobile;